import styled from 'styled-components';
import { InfiniteList } from 'ui-components/src/components/molecules/InfiniteList';

export const StyledInfiniteList = styled(InfiniteList)`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
`;

export const Empty = styled.span`
  text-align: center;
  color: ${({ theme }) => theme.colors.lightGrey};
  margin: ${(props) => props.theme.spacing['32px']};
  line-height: 1.8rem;
`;
